<template>
  <div>
    <object 
      :data='"http://api.organizacionbonet.es:5050/documentos/pdf/" + token' 
      type='application/pdf' 
      width='100%' 
      height='600px'>
      <p>Este navegador no soporta la visualización de documentos PDF. Por favor descargue el documento para poder visualizarlo: 
        <a :href = '"http://api.organizacionbonet.es:5050/documentos/pdf/" + token'>Descargar PDF</a>
      </p>
    </object>
  </div>
</template>

<style>

</style>

<script>


export default {
    name: 'VerDocumento2',
    props: {
      'token': { type: String, required: true }
    }
}
</script>

